"use strict";

// Информация о станции метро

import utils from "../utils";

/* Line colors */
var DEFAULT_COLOR = "CCC";
var LINE_COLORS = {
    "Нижний Новгород": {
        Автозаводская: "D80707",
        Сормовская: "0071BC",
    },
    Екатеринбург: {
        "Север-Юг": "0A6F20",
    },
    Москва: {
        "Арбатско-Покровская": "0072BA",
        "Белорусско-Савеловский": "FF6000",
        "Большая кольцевая линия": "88CDCF",
        "Калининско-Солнцевская": "FFCD1C",
        "Калужско-Рижская": "F07E24",
        "Курско-Рижский": "FF009F",
        "Люблинско-Дмитровская": "BED12C",
        "Серпуховско-Тимирязевская": "ADACAC",
        "Таганско-Краснопресненская": "943E90",
        Бутовская: "BAC8E8",
        Замоскворецкая: "4FB04F",
        Каховская: "88CDCF",
        Кольцевая: "915133",
        Монорельс: "006DA8",
        МЦК: "F9BCD1",
        Сокольническая: "E42313",
        Филёвская: "1EBCEF",
    },
    Казань: {
        Центральная: "CD0505",
    },
    "Санкт-Петербург": {
        "Кировско-Выборгская": "D6083B",
        "Московско-Петроградская": "0078C9",
        "Невско-Василеостровская": "009A49",
        Правобережная: "EA7125",
        "Фрунзенско-Приморская": "702785",
    },
    Новосибирск: {
        Ленинская: "CD0505",
        Дзержинская: "0A6F20",
    },
    Самара: {
        Первая: "CD0505",
    },
};

/* Color for metro line with specified name. */
function line_color(city, line) {
    var colors = LINE_COLORS[city];
    if (colors && colors[line]) {
        return "#" + colors[line];
    } else {
        return "#" + DEFAULT_COLOR;
    }
}

/* HTML description for metro station */
function get_description(city, metro) {
    var color = line_color(city, metro.line);
    var description_parts = [
        '<i class="fa fa-square" style="font-size: 90%; color: ',
        color,
        '"></i>',
        "&#8239;",
        metro.name.replace(" ", "&nbsp;"),
    ];
    if (metro.distance !== 0) {
        Array.prototype.push.apply(description_parts, ["&nbsp;", "(", metro.distance, " км)"]);
    }
    return utils.join(description_parts, "");
}

/* HTML description for multiple metro stations */
function descriptionForMultiple(city, metros) {
    if (!metros) {
        return "";
    }
    var descriptions = [];
    metros.forEach(function (metro) {
        descriptions.push(get_description(city, metro));
    });
    return utils.join(descriptions);
}

export default {
    descriptionForMultiple: descriptionForMultiple,
};
